import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import withDragDropContext from "hocs/withDragDropContext";
import {
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayMove,
  UseFieldArrayRemove,
  UseFormReturn,
} from "react-hook-form";
import SkillsList from "../SkillsList";
import { CompetencyLiteralType, CompetencyMapInputs, SkillsLiteralType } from "../types";

const SkillsListWithDragDropContext = withDragDropContext(SkillsList);

interface IKnowledgeBlockBodyProps {
  name: CompetencyLiteralType;
  isEditable: boolean;
  form: UseFormReturn<CompetencyMapInputs>;
  skillsFields: FieldArrayWithId<CompetencyMapInputs, SkillsLiteralType, "skillId">[];
  removeSkill: UseFieldArrayRemove;
  moveSkill: UseFieldArrayMove;
  appendSkill: UseFieldArrayAppend<CompetencyMapInputs, SkillsLiteralType>;
}

const KnowledgeBlockBody = ({
  name,
  isEditable,
  skillsFields,
  appendSkill,
  removeSkill,
  moveSkill,
  form,
}: IKnowledgeBlockBodyProps) => {
  const knowledgeBlock = form.getValues(name);

  const addSkillBlock = () => {
    appendSkill({ title: "", grades: [] });
  };

  return (
    <Box>
      <SkillsListWithDragDropContext
        droppableId='skillsList'
        moveItems={moveSkill}
        name={`${name}.skills`}
        isEditable={isEditable}
        skills={skillsFields}
        removeSkill={removeSkill}
        knowledgeBlock={knowledgeBlock}
      />
      <Button
        startIcon={<Add sx={{ color: "base.200" }} />}
        variant='contained'
        color='secondary'
        onClick={addSkillBlock}
        disabled={!isEditable}
        sx={{
          mt: 2,
          backgroundColor: "#fff",
          "&:hover": { backgroundColor: "#fff" },
          "&:active": { backgroundColor: "#fff" },
          "&.Mui-disabled": { backgroundColor: "#fff" },
        }}>
        Навык
      </Button>
    </Box>
  );
};

export default KnowledgeBlockBody;
